import { Mic2, User } from "lucide-react";
import { T } from "@/i18n";

const PhotoPlaceholder = ({ testId, large }) => (
  <div
    data-testid={testId}
    className={`gc-photo-placeholder relative flex flex-col items-center justify-center overflow-hidden rounded-2xl border border-dashed border-[#FFE500]/25 ${
      large ? "aspect-[3/4]" : "aspect-[4/5]"
    }`}
  >
    <User className="h-16 w-16 text-white/20" strokeWidth={1} />
    <span className="mt-3 px-4 text-center text-[10px] uppercase tracking-widest text-white/40">
      Official photograph coming soon
    </span>
  </div>
);

export const Speakers = ({ lang }) => {
  return (
    <section id="speakers" data-testid="speakers-section" className="relative py-20 sm:py-28">
      <div className="gc-waves" />
      <div className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6">
        <p data-testid="speakers-sub" className={`text-center text-sm uppercase tracking-[0.3em] text-[#FFE500] ${lang === "kn" ? "font-kn normal-case tracking-normal" : ""}`}>
          {T.speakers.sub[lang]}
        </p>
        <h2 data-testid="speakers-heading" className={`mt-3 text-center font-display text-4xl font-bold uppercase text-white sm:text-5xl ${lang === "kn" ? "font-kn normal-case" : ""}`}>
          {T.speakers.heading[lang]}
        </h2>
        <div className="mt-12 grid items-start gap-8 md:grid-cols-5">
          {/* Main speaker — prominent placement */}
          <div data-testid="speaker-main" className="md:col-span-3">
            <div className="relative">
              <PhotoPlaceholder testId="speaker-photo-main" large />
              <span data-testid="speaker-main-badge" className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-[#FFE500] px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-[#0B1233]">
                <Mic2 className="h-3.5 w-3.5" /> {T.speakers.mainBadge[lang]}
              </span>
            </div>
            <h3 data-testid="speaker-main-name" className="mt-5 font-display text-2xl font-bold uppercase tracking-wide text-white sm:text-3xl">
              Rev. Dr. Babu K Mathew
            </h3>
            <p className={`mt-1 text-sm text-[#FFE500]/80 ${lang === "kn" ? "font-kn" : ""}`}>{T.speakers.mainBadge[lang]}</p>
          </div>
          {/* Translator */}
          <div data-testid="speaker-translator" className="md:col-span-2 md:mt-16">
            <div className="relative">
              <PhotoPlaceholder testId="speaker-photo-translator" />
              <span data-testid="speaker-translator-badge" className="absolute left-4 top-4 rounded-full border border-[#FFE500]/50 bg-[#0B1233]/80 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-[#FFE500]">
                {T.speakers.translatorBadge[lang]}
              </span>
            </div>
            <h3 data-testid="speaker-translator-name" className="mt-5 font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl">
              Pr. John Stephen
            </h3>
            <p className={`mt-1 text-sm text-[#FFE500]/80 ${lang === "kn" ? "font-kn" : ""}`}>{T.speakers.translatorBadge[lang]}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
